// @ts-check

import { useMemo } from "react";
import { pickBy, merge } from "lodash";
import { useWorkspace } from "src/contexts/global/WorkspaceContext";
import useRestricted from "src/app/Restricted/useRestricted";
import { useOrgAnnouncementsForTenant } from "./useOrgAnnouncementsForTenant";
// import { useOrgAnnouncementsForWorkspace } from "./useOrgAnnouncementsForWorkspace";

/**
 * Hook for getting announcement for UI.
 * @returns {{
 *  loading: boolean,
 *  announcement: org_config.tenant.Announcement | null
 * }}
 */
export const useOrgAnnouncement = () => {
  const { loading: loadingTenant, announcements: tenantAnnouncements } =
    useOrgAnnouncementsForTenant();
  const {
    config: { notifications: workspaceAnnouncements },
  } = useWorkspace();
  // TODO: replace with below once ready
  // const { loading: loadingWorkspace, announcements: workspaceAnnouncements } =
  //  useOrgAnnouncementsForWorkspace();

  const [isDirectoryUser, isPowerUser, isAdminUser] = useRestricted();

  // NOTE: we only ever show one announcement at a time. Workspace overrides tenant. Active only.
  const announcement = useMemo(() => {
    const tenantActive = pickBy(tenantAnnouncements, "isActive");
    const workspaceActive = pickBy(workspaceAnnouncements, "isActive");
    const active = merge({}, tenantActive, workspaceActive);

    if (isAdminUser || isPowerUser) {
      return active.mapperNotification;
    }
    if (isDirectoryUser) {
      return active.directoryNotification;
    }
    return null;
  }, [
    tenantAnnouncements,
    workspaceAnnouncements,
    isAdminUser,
    isPowerUser,
    isDirectoryUser,
  ]);

  return {
    loading: loadingTenant /* || loadingWorkspace */,
    announcement,
  };
};
